import { Nullable } from '@client/core/data/types';
import { CompanyCategory } from '@client/features/company/models/company-category';
import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { JsonResponse } from '@client/core/data/concerns/parses-from-json/types';

/**
 * A vendor that a User may engage with to accomplish work on their Project.
 *
 * @see app/Company.php
 */
export class Company {
  constructor(
    public readonly id: number,
    public readonly uuid: string,
    public readonly name: string,
    public readonly category: Nullable<CompanyCategory>,
    public readonly email: Nullable<string>,
    public readonly phone: Nullable<string>,
    public readonly notes: Nullable<string>,
  ) {}
}

defineTransform(Company, (json: JsonResponse, { fromSnakeCaseKeys }) => {
  return {
    // TODO: Is category field being properly converted?
    ...fromSnakeCaseKeys(),
  };
});
